export interface BankModel {
  name: string;
  locality: string;
  country: string;
  code: string;
  bic: string;
}

export interface BankAccountModel {
  number: string;
  iban: string;
  bank: BankModel;
}

export interface AddressModel {
  country: string;
  locality: string;
  region: string;
  postalCode: string;
  streetAddress: string;
  postOfficeBoxNumber: string;
}

export type CustomerBlockingStatus = 'none' | 'partiallyBlocked' | 'fullyBlocked';

/* istanbul ignore next */
export const CustomerBlockingStatusBlocked: CustomerBlockingStatus[] = ['fullyBlocked', 'partiallyBlocked'];

export type CustomerFeatureName = never;

export interface CustomerUserPermissions {
  canSeePrices: boolean;
  canUseServices: boolean;
  canUseSrm: boolean;
  canUseShop: boolean;
}

export interface CustomerCategorizingModel {
  /** Business Model Independent, a strategic business model by Lekkerland for customers in the independent market */
  bmi: boolean;
  /** Assigned regional market. */
  regionalMarket?: string;
  /** Calendar week campaign identifier (Kalenderwochenaktionskennzeichen). Used to assign customers to specific campaigns  */
  kwa?: string;
  /** Distinguishes different pricing files within BMI, e.g. ZCD5. */
  zanr?: string;
  /** Partner Role for central classification, used to structure and categorize customers in SAP. */
  pzo?: string;
}

export interface CustomerBaseModel {
  alias?: string;
  mainUser: boolean;
  id: string;
  customerCategorizing?: CustomerCategorizingModel;
  yaci: string;
  name: string;
  country: string;
  locale: string;
  phoneNumbers: string[];
  emailAddresses: string[];
  bank?: BankAccountModel;
  address?: AddressModel;
  tobacco: boolean;
  isDefault: boolean;
  blockingStatus: CustomerBlockingStatus;
  features: CustomerFeatureName[];
  customerUserPermissions: CustomerUserPermissions;
  shopCustomerId?: string;
}

export interface CustomerModel extends CustomerBaseModel {
  invoiceRecipient: CustomerBaseModel;
  deliveryRecipient: CustomerBaseModel;
}
